import { useEffect } from "react";
import { getIsIpDomain } from "../../../../utils";
import AccessLimitLayout from "./components/_access-limit-layout";

const title = "Acesso indisponível";

const description = (
  <>
    A conta corporativa à qual você está vinculado está com o acesso
    indisponível no momento.
    <br />
    <br />
    Isso pode ocorrer devido à expiração ou à desativação da conta. Caso sua
    instituição esteja realizando uma renovação ou regularização, o acesso será
    restabelecido após a conclusão do processo.
    <br />
    <br />
    Para mais informações, entre em contato com o administrador da sua
    instituição.
  </>
);

const IpAccountUnavailable = () => {
  const isIpDomain = getIsIpDomain();

  useEffect(() => {
    if (!isIpDomain) {
      window.location.href = "/";
    }
  }, []);

  return <AccessLimitLayout title={title} description={description} />;
};

export default IpAccountUnavailable;
